
  function runVisibleGlightbox() {
    // Destroy existing GLightbox instance if it exists
    if (window.glightboxInstance && typeof window.glightboxInstance.destroy === 'function') {
      window.glightboxInstance.destroy();
    }

    // Clear any previous 'glightbox-visible' classes
    document.querySelectorAll('.glightbox-visible').forEach(el => {
      el.classList.remove('glightbox-visible');
    });

    // Add 'glightbox-visible' class to visible elements
    document.querySelectorAll('.glightbox').forEach(function(el) {
      if (el.offsetParent !== null) {
        el.classList.add('glightbox-visible');
      }
    });

    const visibleElements = document.querySelectorAll('.glightbox-visible');
    visibleElements.forEach(el => {
      if (el.hasAttribute('tabindex')) {
        el.removeAttribute('tabindex');
      }
    });
    if (visibleElements.length > 0) {
      const firstElement = visibleElements[0];
      if (!firstElement.hasAttribute('tabindex')) {
        firstElement.setAttribute('tabindex', '-1');
      }
      firstElement.focus();
    }

    if ( typeof GLightbox === 'function') {
      // Initialize GLightbox only for visible elements
      window.glightboxInstance = GLightbox({ selector: '.glightbox-visible' });
    }
  }

  function _select_gallery_img(){
    if($(window).outerWidth() > 768){
      console.log(".variant-img click triggered")
      setTimeout(function(){
        $(".onecol-big-thumb .product-gallery-item").removeClass("first");
        $(".onecol-big-thumb .product-gallery-item:visible").eq(0).addClass("first");
        console.log(".variant-img click executed")
        runVisibleGlightbox();
      },200)
    }
  }
  let ignoreNextMutation = false;

  // Function you want to run on DOM change
  function updateFirstVisibleItem() {
    if (ignoreNextMutation) return;

    ignoreNextMutation = true;

    $(".onecol-big-thumb .product-gallery-item").removeClass("first");
    $(".onecol-big-thumb .product-gallery-item:visible").eq(0).addClass("first");
    console.log(".variant-img click executed");

    // Allow mutations again after a brief moment
    setTimeout(() => {
      ignoreNextMutation = false;
    }, 50);
  }

  // Observe DOM changes
  const targetNode = document.querySelector(".onecol-big-thumb");
  if (targetNode) {
    const observer = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
        if (mutation.type === "childList" || mutation.type === "attributes") {
          updateFirstVisibleItem();
          break;
        }
      }
    });

    observer.observe(targetNode, {
      attributes: true,
      childList: true,
      subtree: true
    });
  }

  // Optionally, trigger once on load
  $(window).on("load", function () {
    updateFirstVisibleItem();
  });
